export default __webpack_public_path__ + "static/media/table.bd2a2409.svg";